/** Ids of the tab / panel elements for `Tabs` with an `idBase` (callers put `id={tabPanelId(base, id)}` on the panel). */
export const tabId = (base: string, id: string) => `${base}-tab-${id}`;
export const tabPanelId = (base: string, id: string) => `${base}-panel-${id}`;
